import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Download = function Download(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.9971 13H1.99805V10.9971H12.9971V13ZM5.99707 6V2.00098H8.99805V6H11.7803L7.42578 10.5596L3.24219 6H5.99707Z",
    clipRule: "evenodd"
  })));
};